import { render, staticRenderFns } from "./DeviceDocs.vue?vue&type=template&id=ce44b3c6&scoped=true"
import script from "./DeviceDocs.vue?vue&type=script&lang=js"
export * from "./DeviceDocs.vue?vue&type=script&lang=js"
import style0 from "./DeviceDocs.vue?vue&type=style&index=0&id=ce44b3c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce44b3c6",
  null
  
)

export default component.exports